// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__WiVr0","resendInfoText":"OnGoingPaymentBox_resendInfoText__2k9GY"};